export default {
  number: {
    decimal: { style: "decimal", minimumFractionDigits: 2 },
  },
};
